export default () => {
	let $video = $('.img-placeholder'),
		$videoIframe = $('.card-img-video iframe');

	$video.on ('click', function () {
		$(this).fadeOut('slow');
		$videoIframe[0].src += "&autoplay=1";
		console.log($videoIframe);
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/_play-video.js